import { render } from "./App.vue?vue&type=template&id=2eec5b3a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2eec5b3a&lang=css"
import "./App.vue?vue&type=style&index=1&id=2eec5b3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2eec5b3a"

export default script